var MenuContent;
(function($){

    MenuContent = {

        $menus: null,
        breakpoint: 675,
        timeout: false,
        lastGadget: false,

        init : function(){

            this.$menus = $( '.menu-content' );
            if( !this.$menus.length ) return false;

            this.$menus.each(function(){

                this.$ = this.$ || $( this );
                var data = this.$.data( 'MenuContent' );
                if( data ) return true;

                data = {
                    _ : this,
                    $ : this.$,
                    $menu: $( 'ul', this.$ ).first()
                }
                data.$items = $( 'li', data.$menu );
                data.$contents = $( '.content', data.$menu );

                if( !data.$items.length ) return true;

                // Keep data
                this.$.data( 'MenuContent', data );

                MenuContent.configure( data );

            });

            $( window ).bind( 'resize', function(){
                MenuContent.bindResize();
            }).resize();

        },

        configure : function( data ){

            data.$items.each(function(){

                this.$ = this.$ || $( this );
                
                var itemData = {
                    $ : this.$,
                    $trigger : $( 'h4', this.$ ).first(),
                    $content : $( '.content', this.$ ).first()
                };

                this.$.data( 'MenuContent', itemData );

                // Hover
                itemData.$trigger.hover(
                    function(){
                        if( !MenuContent.isMobile() ){ 
                            MenuContent.open( data, itemData );
                        }
                    },
                    function(){
                        if( !MenuContent.isMobile() ){ 
                            MenuContent.close( data, itemData );
                        }
                    }
                );

                // Click
                itemData.$trigger.on( 'click', function( e ){
                
                    e.preventDefault();

                    // Check if is opened
                    var isOpened = itemData.$.hasClass( 'active' );

                    // Close all
                    MenuContent.closeAll( data );

                    // Open if closed
                    if( !isOpened ){
                        MenuContent.open( data, itemData );
                    }
                
                });
            
            });

        },

        bindResize : function(){

            if( MenuContent.timeout ) clearTimeout( MenuContent.timeout );
            
            MenuContent.timeout = setTimeout(function(){
                MenuContent.checkSize();
            }, 100 );
        
        },

        checkSize: function(){

            var isMobile = this.isMobile();
            var newGadget = isMobile ? 'mobile' : 'desktop';

            if( this.lastGadget === newGadget ) return;
            this.lastGadget = newGadget;

            // Each menu
            for( var mns = 0; mns < this.$menus.length; mns++ ){

                var data = this.$menus.eq( mns ).data( 'MenuContent' );
                var openedIndex = data.$items.filter( '.active' ).index();
                if( openedIndex < 0 ) openedIndex = 0;
                
                // Remove opened class
                data.$items.removeClass( 'active' );
                
                if( newGadget === 'desktop' ){
                    
                    data.$contents.show();
                
                }
                else {

                    // Close all
                    data.$contents.hide();

                    // Open one
                    var $toOpen = data.$items.eq( openedIndex );
                    var dataOpen = $toOpen.data( 'MenuContent' );
                    MenuContent.open( data, dataOpen, false );
                
                }

            }

        },

        open : function( data, dataItem, slideTo ){

            // Close others
            MenuContent.closeAll( data );

            // Open element
            dataItem.$.addClass( 'active' );
            if( MenuContent.isMobile() ){
                
                dataItem.$content.stop( true, true ).slideDown( 500, function(){
                    if( slideTo !== false ){
                        $( window ).scrollTo( 
                            dataItem.$, 
                            400, 
                            { 
                                offset: { top: -30 } 
                            } 
                        );
                    }
                });
            
            }
        
        },

        // Close an item
        close : function( data, dataItem ){

            dataItem.$.removeClass( 'active' );
            
            if( MenuContent.isMobile() ){
                dataItem.$c.slideUp( 500 );
            }
        
        },

        // Fecha todos os ítems
        closeAll : function( data ){

            for( var tis=0; tis < data.$items.length; tis++ ){
                
                // Data item
                var dataItem = data.$items.eq( tis ).data( 'MenuContent' );

                // Remove class
                dataItem.$.removeClass( 'active' );

                // Close content if mobile
                if( MenuContent.isMobile() ){
                    dataItem.$content.slideUp( 500 );
                }

            }

        },

        isMobile : function(){
            var is_mobile = MenuContent.vw() <= MenuContent.breakpoint;
            return is_mobile;
        },

        vw : function(){
            var viewport_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            return viewport_width;
        }

    };
    $(function(){
        MenuContent.init();
    });

})(jQuery);